import { createSelector } from 'reselect';
import CarrierResdit7421PerformanceOperatorPercentageColumns from '../../containers/CarrierResdit7421PerformanceOperatorPercentageColumns';
import CarrierResdit7421PerformanceOperatorNumberColumns from '../../containers/CarrierResdit7421PerformanceOperatorNumberColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.RESDIT_74_21_PERFORMANCE_OPERATOR_802.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.RESDIT_74_21_PERFORMANCE_OPERATOR_802.isLoading;

export const getData =
  ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.getDataFunction();

export const getPercentageColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.RESDIT_74_21_PERFORMANCE_OPERATOR_802.requestParams, CarrierResdit7421PerformanceOperatorPercentageColumns);

export const getNumberColumns =
  // eslint-disable-next-line max-len
  createSelector(getData, state => state.reporting.RESDIT_74_21_PERFORMANCE_OPERATOR_802.requestParams, CarrierResdit7421PerformanceOperatorNumberColumns);
